

import ViewUI from 'view-design'
export default function ViewDesign(Vue){
    Vue.use(ViewUI)
}